import React from 'react';
import { Link } from 'react-router-dom';
import {
  LuBookOpen,
  LuCalendarClock,
  LuChevronDown,
  LuMap,
  LuRoute,
} from 'react-icons/lu';
import HubAppJourney from './HubAppJourney';

function PlaybookRow({ row }) {
  return (
    <li className="hub-guide-row">
      <span className="hub-guide-row-label">{row.label}</span>
      <span className="hub-guide-row-desc">
        {row.text}
        {row.link ? (
          <>
            {' '}
            <Link to={row.link.to}>{row.link.label}</Link>
          </>
        ) : null}
      </span>
    </li>
  );
}

export default function HubPlaybook({ when = [], how = [], what = [], journeyHighlight }) {
  return (
    <details className="hub-playbook">
      <summary className="hub-playbook-summary">
        <span className="hub-playbook-summary-main">
          <span className="hub-playbook-summary-icon" aria-hidden>
            <LuMap />
          </span>
          <span className="hub-playbook-summary-text">
            <span className="hub-playbook-summary-label">Guide &amp; application journey</span>
            <span className="hub-playbook-summary-hint">When to use each area · full end-to-end flow</span>
          </span>
        </span>
        <LuChevronDown className="hub-playbook-chevron" aria-hidden />
      </summary>

      <div className="hub-playbook-body">
        <div className="hub-guide-grid">
          <div className="hub-guide-card hub-guide-card--when">
            <div className="hub-guide-card-head">
              <h3>
                <LuCalendarClock aria-hidden />
                When
              </h3>
            </div>
            <ul>
              {when.map((row) => (
                <PlaybookRow key={row.label} row={row} />
              ))}
            </ul>
          </div>
          <div className="hub-guide-card hub-guide-card--how">
            <div className="hub-guide-card-head">
              <h3>
                <LuRoute aria-hidden />
                How
              </h3>
            </div>
            <ol>
              {how.map((row, i) => (
                <li key={row.label} className="hub-guide-row hub-guide-row--step">
                  <span className="hub-guide-step-num">{i + 1}</span>
                  <span className="hub-guide-row-stack">
                    <span className="hub-guide-row-label">{row.label}</span>
                    <span className="hub-guide-row-desc">{row.text}</span>
                  </span>
                </li>
              ))}
            </ol>
          </div>
          <div className="hub-guide-card hub-guide-card--what">
            <div className="hub-guide-card-head">
              <h3>
                <LuBookOpen aria-hidden />
                What
              </h3>
            </div>
            <ul>
              {what.map((row) => (
                <PlaybookRow key={row.label} row={row} />
              ))}
            </ul>
          </div>
        </div>

        <HubAppJourney highlight={journeyHighlight} />
      </div>
    </details>
  );
}
